module.exports = __webpack_public_path__ + "static/media/addMedication.05b7e28f.PNG";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/addMedication.PNG
// module id = 393
// module chunks = 0